import React from 'react';
import { CareersHero } from '../components/careers/CareersHero';
import { WhyGuru } from '../components/careers/WhyGuru';
import { ApplicationSection } from '../components/careers/ApplicationFunnel';
import { GuruWorld } from '../components/careers/GuruWorld';
import { HiringNext } from '../components/careers/HiringNext';
import '../styles/careers.css';
import '../styles/careers-app.css';

// Approved "Become A Guru" careers page (locked design, see /memory/careers-source).
const CareersPage = () => (
  <div className="careers" data-testid="careers-page">
    <div className="hp2-masthead-spacer" aria-hidden="true" />
    <main>
      <CareersHero />
      <WhyGuru />
      <ApplicationSection />
      <GuruWorld />
      <HiringNext />
    </main>
  </div>
);

export default CareersPage;
